import { render, staticRenderFns } from "./AQuotationAmount.vue?vue&type=template&id=1c5e91b4&"
import script from "./AQuotationAmount.vue?vue&type=script&lang=js&"
export * from "./AQuotationAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports